// Add your own Custom Turbo StreamActions
// Define Rails helpers in `app/helpers/turbo_stream_actions_helper.rb`
//
// These actions run in the context of a turbo-stream element. You have access to methods like the following:
//
//   this.action - The action attribute value (for example: "append")
//   this.target - The target attribute value (the target element ID)
//   this.targetElements - An array of target elements the template will be rendered to
//   this.templateContent - The contents of the main `<template>`
//
// Source code for the stream element can be found here:
// https://github.com/hotwired/turbo/blob/main/src/elements/stream_element.ts

import { Turbo } from '@hotwired/turbo-rails'

// Remove elements after X milliseconds
// <%= turbo_stream.remove_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.remove_later = function () {
  setTimeout(() => {
    this.targetElements.forEach((element) => element.remove())
  }, this.getAttribute('after'))
}

// Resets a form
// <%= turbo_stream.reset_form "new_post"
Turbo.StreamActions.reset_form = function () {
  this.targetElements.forEach((element) => element.reset())
}

// Scrolls an element into view
// <%= turbo_stream.scroll_to "comment_1"
Turbo.StreamActions.scroll_to = function () {
  this.targetElements.forEach((element) =>
    element.scrollIntoView({ behavior: 'smooth' })
  )
}

Turbo.StreamActions.replace_message_id = function () {
  const replace_with = this.getAttribute('replace_with')
  this.targetElements.forEach((element) => (element.id = replace_with))
}

Turbo.StreamActions.dispatch_event = function () {
  const name = this.getAttribute('name')
  console.log('name ', name)
  let template = null

  try {
    template = this.templateContent.textContent
  } catch (e) {
    // default to empty object
  }

  try {
    const detail = template ? JSON.parse(template) : {}

    if (name) {
      const options = { bubbles: true, cancelable: true, detail }
      const event = new CustomEvent(name, options)

      this.targetElements.forEach((element) => element.dispatchEvent(event))
    } else {
      console.warn(
        `[TurboPower] no "name" provided for Turbo Streams operation "dispatch_event"`
      )
    }
  } catch (error) {
    console.error(
      `[TurboPower] error proccessing provided "detail" in "<template>" ("${template}") for Turbo Streams operation "dispatch_event".`,
      `Error: "${error.message}"`
    )
  }
}
